__turbopack_context__.v({
  "earningsChartWrapper": "index-module-scss-module__VeNhRq__earningsChartWrapper",
});
